import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { jobCancelledEndpoint } from '../../../common/endpoints';

// Create an API thunk for fetching data
export const jobCancelledApi = createApi(jobCancelledEndpoint, 'POST');

const JobCancelled = createSlice({
  name: 'JobCancelled',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(jobCancelledApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(jobCancelledApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(jobCancelledApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default JobCancelled.reducer;